import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import AnonymousAvatarMini from "components/commons/AnonymousAvatarMini"
import AvatarMini from "components/commons/AvatarMini"


export default function WhistleCard({
    whistle,
    isManageable = false,
    onStatusChange,
    onUrgencyChange,
}) {

    const [t] = useTranslation(["global", "whistle"])

    const statusColor = () => {
        switch (whistle.status) {
            case "OPEN": return "light"
            case "IN_CHARGE": return "warning"
            case "SOLVED": return "success"
            default: return "dark"
        }
    }

    const statusIcon = () => {
        switch (whistle.status) {
            case "CLOSED": return <i className="fa-solid fa-circle-xmark"></i>
            case "SOLVED": return <i className="fa-solid fa-circle-check"></i>
            default: return
        }
    }

    const statusLabel = () => {
        return statusLabelByStatus(whistle.status)
    }

    const statusLabelByStatus = (status) => {
        switch (status) {
            case "OPEN": return t("whistle:entity.warning.status.open")
            case "IN_CHARGE": return t("whistle:entity.warning.status.in_charge")
            case "SOLVED": return t("whistle:entity.warning.status.solved")
            case "CLOSED": return t("whistle:entity.warning.status.closed")
            default: return
        }
    }

    const dateString = new Date(whistle.createdAt).toLocaleDateString() == new Date().toLocaleDateString() ? t("time.today") : new Date(whistle.createdAt).toLocaleDateString()

    if (isManageable)

        return <div className={`card  bg-opacity-10 mb-2 text-white bg-${statusColor(whistle.status)}`} onClick={() => { }} style={{ borderRadius: "1em" }}>
                <div className="card-body text-center p-3">
                    <div className="row text-start">
                        <div className="col-sm-2">

                            {
                                whistle.status != "SOLVED" && whistle.status != "CLOSED" ?

                                    <div className="dropdown">
                                        <button className={`btn btn-${statusColor(whistle.status)} dropdown-toggle`} type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                            {statusLabel()}
                                        </button>
                                        <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton2">
                                            <li className="px-2">{t("whistle:action.mark_as")}</li>
                                            {
                                                whistle.status == "OPEN" &&
                                                <h5 onClick={() => { onStatusChange(whistle.guid, "IN_CHARGE") }}><a className="dropdown-item bg-warning text-dark badge mx-1">{statusLabelByStatus("IN_CHARGE")}</a></h5>
                                            }
                                            <h5 onClick={() => { onStatusChange(whistle.guid, "SOLVED") }}><a className="dropdown-item bg-success  badge mx-1">{statusLabelByStatus("SOLVED")}</a></h5>
                                            <h5 onClick={() => { onStatusChange(whistle.guid, "CLOSED") }}><a className="dropdown-item bg-secondary  badge mx-1">{statusLabelByStatus("CLOSED")}</a></h5>

                                        </ul>
                                    </div>




                                    :
                                    <button className={`btn btn-${statusColor(whistle.status)}`} type="button">
                                        {statusIcon()} {statusLabel()}
                                    </button>
                            }

                        </div>
                        <div className="col-sm-1">
                            <h5 onClick={() => {
                                if (whistle.status != "CLOSED" && whistle.status != "SOLVED")
                                    onUrgencyChange(whistle.guid, !whistle.isUrgent)
                            }} className={`text-${whistle.isUrgent ? "danger" : "secondary"}`}><i className={`fa-solid fa-flag `}></i></h5>
                        </div>
                        <div className="col-sm-5">
                            <h5 >{whistle.title}</h5>
                            <span className="text-muted small">{t("whistle:helper.click_to_open")}</span>
                        </div>
                        <div className="col-sm-3">
                            {whistle.whistler ?
                                <AvatarMini
                                    displayName={whistle.whistler.displayName}
                                    guid={whistle.whistler.guid} />
                                : <AnonymousAvatarMini />
                            }
                        </div>
                        <div className="col-sm-1">
                            {dateString}
                        </div>
                    </div>
                </div>
            </div>

    else
        return <div className={`card  bg-opacity-10 mb-2 text-white bg-${statusColor(whistle.status)}`} style={{ borderRadius: "1em" }}>
            <div className="card-body text-center p-3">
                <div className="row text-start">
                    <div className="col-sm-3">
                        <button className={`btn btn-${statusColor(whistle.status)}`} type="button">
                            {statusIcon()} {statusLabel(whistle.status)}
                        </button>
                    </div>
                    <div className="col-sm-1">
                        <h5 className={`text-${whistle.isUrgent ? "danger" : "secondary"}`}><i className={`fa-solid fa-flag `}></i></h5>
                    </div>
                    <div className="col-md-5">
                        <Link className="text-white" style={{ textDecoration: "unset" }}>
                            <h5 >{whistle.title}</h5>
                            <span className="text-muted small">{t("whistle:helper.click_to_open")}</span>
                        </Link>
                    </div>

                    <div className="col-md-3">
                        {dateString}
                    </div>
                </div>
            </div>
        </div>
}